import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Ticker = () => {
  const [quote, setQuote] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let stopped = false;
    let controller;
    const load = async () => {
      controller?.abort();
      controller = new AbortController();
      try {
        const res = await fetch(`${API}/market/gold`, { signal: controller.signal });
        if (!res.ok) throw new Error("unavailable");
        const data = await res.json();
        if (!stopped) { setQuote(data); setFailed(false); }
      } catch (e) {
        if (!stopped && e.name !== "AbortError") setFailed(true);
      }
    };
    load();
    const timer = setInterval(load, 60000);
    return () => { stopped = true; controller?.abort(); clearInterval(timer); };
  }, []);

  const time = quote?.fetched_at
    ? new Date(quote.fetched_at).toUTCString().slice(17, 22) + " UTC"
    : null;

  return (
    <div
      data-testid="gold-ticker"
      className="h-9 flex items-center justify-center gap-3 bg-[#0A0A0B] hairline-b font-mono2 text-[11px] tracking-[0.18em] uppercase"
      aria-live="off"
    >
      <span className={`w-1.5 h-1.5 rounded-full ${quote && !quote.stale ? "bg-[#C9A227]" : "bg-zinc-600"}`} aria-hidden="true" />
      <span className="text-zinc-500">XAU / USD</span>
      {quote ? (
        <>
          <span className="text-[#E8C85A] tabular-nums" data-testid="gold-ticker-price">
            {quote.price.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </span>
          <span className="text-zinc-600 hidden sm:inline">per troy oz</span>
          <span className="text-zinc-600 hidden md:inline">· {time}</span>
          {quote.stale && <span className="text-amber-600" data-testid="gold-ticker-stale">Delayed</span>}
        </>
      ) : (
        <span className="text-zinc-600">{failed ? "Spot feed unavailable" : "Loading spot…"}</span>
      )}
    </div>
  );
};
